<template>
  <div id="app-nav">
    <ul class="sidebar-menu">
       <li class="header form-inline">
        <div class="form-group">
          <select v-model="selectedKeyword" class="form-control width150">
            <option value="">--All Keywords--</option>
            <option v-for="(keyword, keywordIndex) in keywords" :value="keyword" :key="keywordIndex">
              {{keyword}}
            </option>
          </select>
        </div>
        <div class="form-group">
          <button type="submit" class="btn btn-primary" v-on:click="selectKeywordAction()">Go</button>
        </div>
      </li>
      <li class="header form-inline">
        <div class="form-group">
          <select class="form-control" v-model="action" v-on:change="checkAction()">
            <option value="">--Select--</option>
            <option value="claim">Claim Chats</option>
            <option value="release">Release Chats</option>
            <option value="releaseAll">Release All Chats</option>
          </select>
        </div>
        <div class="form-group">
          <button type="submit" class="btn btn-primary" v-on:click="takeAction()" :disabled="!action || processing">{{processing ? '...' : 'Go'}}</button>
        </div>
      </li>

       <!-- <li class="header form-inline">
        <div class="form-group form-control">
        <input type="checkbox" name="usertype" value="sms"> Sms &nbsp;
          <input type="checkbox" name="usertype" value="whatsapp"> WhatsApp &nbsp;
         <input type="checkbox" name="usertype" value="messenger"> Messenger
        </div>
      </li> -->
         <li class="header form-inline">
            <div class="form-group">
            <select class="form-control" v-model="selectedUsertype" v-on:change="checkSelectedUsertype()">
              <option value="">--All--</option>
              <option value="whatsapp">WhatsApp</option>
              <option value="messenger">Messenger</option>
              <option value="sms">SMS</option>
            </select>
        </div>
        <div class="form-group">
            <select class="form-control" v-model="selectedSort" v-on:change="checkSelectedSort()" >          
                <option value="asc" >Ascending</option>
                <option value="desc" selected>Descending</option>
              </select>
        </div>
      </li>

      <li
        class="treeview"
        :key="groupIndex"
        v-for="(eachGroup, groupIndex) in [{value: agentSessions, name: 'My Chats', key: 'agentSessions'}, {value: generalSessions, name: 'General Chats', key: 'generalSessions'}]">
        <a href="#">
          <i class="fa fa-comments"></i> <span>{{eachGroup.name}}</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li v-for="(each, index) in eachGroup.value" :key="index" :class="each && each.current ? 'current' : ''">
            <router-link :to="'/summary/'+each.user">
              <span :class="each.new ? 'new-message' : ''" v-on:click="activateChat(eachGroup.key, index)">
               
                {{each.user}}
                <br/>
                <span class="time">{{each.time}}</span>
              </span>
            </router-link>
            <div>
                <i class="fa fa-whatsapp fa-lg whatsapp padding-right_17px"  v-if="each.usertype === 'whatsapp'"></i>
                <i class="fa fa-facebook fa-lg messenger padding-right_17px"  v-if="each.usertype === 'messenger'"></i>
                <i class="fa fa-comments fa-lg sms padding-right_17px"  v-if="each.usertype === 'sms'"></i>
            <input type="checkbox" :value="each.user" v-model="checkedUsers" />
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  import io from 'socket.io-client';
  import { mapActions, mapState, mapGetters } from 'vuex';
  import { getUser } from '../utils/auth';

  export default {
    name: 'app-nav',
    methods: {
      async selectKeywordAction() {
        if (this.selectedKeyword) {
          await this.loadSession(); // Refresh before filter
          const sessionsFilteredByKeyword = this.generalSessions.filter(session =>
            session.keyword === this.selectedKeyword);
          this.filterActiveSessions(sessionsFilteredByKeyword);
        } else {
          // Refresh general sessions
          await this.loadSession();
        }
      },
      /**
       * @function handleIncomingMessage
       * @param {object} details the details of the incoming message {message, user, type}
       * @param {string} sessionType generalSessions or sessions
       */
      handleIncomingMessage(details, sessionType) {
        const index = this.getChatIndex(details.user, sessionType);
        if (details.type === 'user' || details.type === 'automated') {
          this.newChatSessionMessage({
            index,
            sessionType,
            update: {
              new: true,
              user: details.user,
              time: details.time,
              keyword: details.keyword,
              usertype: details.usertype || this.getUserType(details.user)
            }
          });
        }
      },
      getUserType(user) {
        let usertype = 'messenger';
        if (user.startsWith('+')) {
          usertype = 'sms';
        } else if (user.startsWith('91') || user.startsWith('254')) {
          usertype = 'whatsapp';
        }
        return usertype;
      },
      /**
       * @function getMessages
       * @description listen to sockets channels, incoming-message, personal messages
       * @description read-chat and end channels
       */
      getMessages() {
        let socket;
        if (window.location.host.includes('localhost')) {
          socket = io('http://localhost:3000');
        } else {
          socket = io();
        }
        // listens to all incoming general messages
        socket.on('incoming-message', (details) => {
          // check if the incoming phone number exists in the array
          this.handleIncomingMessage(details, 'generalSessions');
        });

        // listens only to messages owned by this CSA
        socket.on(this.agent, (details) => {
          this.handleIncomingMessage(details, 'agentSessions');
        });

        socket.on('read-chat', ({ user }) => {
          this.markChatRead(user);
        });

        socket.on('end', ({ user }) => {
          const { index, sessionType } = this.getChatSessionType(user);
          if (sessionType) {
            this.endChatSession({ index, sessionType });
            this.redirectUser(index, sessionType, user);
          }
        });

        socket.on('claimorrelease', ({ type, accountids, agent }) => {
          // remove those accountids from general pool
          // and add it to the
          if (type === 'claim') {
            // reset the checkbox, to avoid claiming something that been claimed
            this.checkedUsers = [];
            this.claimChats({ accountids, agent, currentAgent: this.agent });
          } else if (type === 'release') {
            const usersToRelease = [];
            if (agent === this.agent) {
              accountids.forEach((each) => {
                // get those users sessions, they can only be available in the chats' owners sessions
                const index = this.getChatIndex(each, 'agentSessions');
                usersToRelease.push(this.agentSessions[index]);
                this.endChatSession({
                  sessionType: 'agentSessions',
                  index
                });
              });
              // emit an event for everybody with the chat sessions
              // that should be put back in the pool
              socket.emit('release', {
                released: usersToRelease
              });
            }
          }
        });

        socket.on('chats-release', (users) => {
          this.addNewChatSessions({
            sessionType: 'generalSessions',
            session: users.released
          });
        });
      },

      /**
       * @function getActiveUser
       * @description gets list of all active users with active chat sessions
       */
      async getActiveUsers() {
        await this.loadSession();
        if (!this.$route.params.accountid) {
          // check if there's a current page saved in the localstorage
          const currentpage = localStorage.getItem('currentpage');
          if (currentpage) {
            this.$router.push(`/summary/${currentpage}`);
            const { index, sessionType } = this.getChatSessionType(currentpage);
            this.setActiveChat(this.formatPayload(currentpage, true, sessionType, index));
            localStorage.removeItem('currentpage');
          } else if (this.agentSessions.length) {
            this.$router.push(`/summary/${this.agentSessions[0].user}`);
            this.setActiveChat(this.formatPayload(this.agentSessions[0].user, true, 'agentSessions'));
          }
        } else {
          this.setActiveChat(this.formatPayload(this.$route.params.accountid, true));
        }
      },

      /**
       * @function activateChat adds green background to a phone number
       * @param {string} sessionType the type of chat the session belongs to
       * @param {number} index the index of the phone number
       */
      activateChat(sessionType, index) {
        this.setActiveChat(this.formatPayload(null, true, sessionType, index));
      },

      /**
       * @function checkAction
       * @description if user selects release all chats, then check all sessions the user owns
       */
      checkAction() {
        if (this.action === 'releaseAll') {
          const users = this.agentSessions.map(each => each.user);
          this.checkedUsers = users;
        } else if (this.action === '') {
          this.checkedUsers = [];
        }
      },

      async loadSession() {
        const paramFilter = {
          userType: this.selectedUsertype,
          sortBy: this.selectedSort
        };
        await this.loadActiveSessions(paramFilter);
      },
      /**
       * @function checkSelectedUsertype
       * @description if user selects change user type
       */
      async checkSelectedUsertype() {
        await this.loadSession();
        if (this.agentSessions.length) {
          this.$router.push(`/summary/${this.agentSessions[0].user}`);
          this.setActiveChat(this.formatPayload(this.agentSessions[0].user, true, 'agentSessions'));
        } else if (this.generalSessions.length) {
          this.$router.push(`/summary/${this.generalSessions[0].user}`);
          this.setActiveChat(this.formatPayload(this.generalSessions[0].user, true, 'generalSessions'));
        }
      },
      /**
       * @function checkSelectedSort
       * @description if user change sort type
       */
      async checkSelectedSort() {
        await this.loadSession();
        if (this.agentSessions.length) {
          this.$router.push(`/summary/${this.agentSessions[0].user}`);
          this.setActiveChat(this.formatPayload(this.agentSessions[0].user, true, 'agentSessions'));
        } else if (this.generalSessions.length) {
          this.$router.push(`/summary/${this.generalSessions[0].user}`);
          this.setActiveChat(this.formatPayload(this.generalSessions[0].user, true, 'generalSessions'));
        }
      },

      /**
       * @function takeAction
       * @description claim or release chats
       */
      takeAction() {
        if (this.action === 'claim') {
          // get all checked phone numbers
          this.performAction('claim', this.checkedUsers);
        } else if (this.action === 'release' || this.action === 'releaseAll') {
          this.performAction('release', this.checkedUsers);
        }
      },

      /**
       * @function performAction
       * @description makes the endpoint request for claiming and relinquinshing chat sessions
       * @param {string} url endpoint url
       * @param {Array} accountids an array of all the checked phone numbers
       */
      async performAction(url, accountids) {
        this.processing = true;
        await this.performClaimOrRelease({
          url,
          accountids,
          agent: this.agent
        });
        this.checkedUsers = [];
        this.processing = false;
      },
      /**
       * @function formatPayload
       * @description makes the endpoint request for claiming and relinquinshing chat sessions
       * @param {string} phoneNumber user phone number
       * @param {boolean} type should the chat be marked as active or not
       * @param {string} typeOfSession is it generalSession or agentSession
       * @param {number} chatIndex index of the chat to mark
       * @returns {object}
       */
      formatPayload(phoneNumber, type, typeOfSession, chatIndex = -1) {
        return {
          phoneNumber,
          type,
          typeOfSession,
          chatIndex
        };
      },
      redirectUser(index, sessionType, user) {
        const nextChatIndex = index > 0 ? index - 1 : 0;
        if (this.$route.params.accountid === user && this[sessionType].length) {
          this.$router.push(`/summary/${this[sessionType][nextChatIndex].user}`);
          this.setActiveChat(this.formatPayload(null, true, sessionType, nextChatIndex));
        } else if (!this[sessionType].length) {
          this.$router.push('/summary/');
        }
      },
      ...mapActions([
        'loadActiveSessions',
        'setActiveChat',
        'newChatSessionMessage',
        'endChatSession',
        'markChatRead',
        'claimChats',
        'addNewChatSessions',
        'performClaimOrRelease',
        'filterActiveSessions'
      ])
    },
    data() {
      return {
        agent: getUser().nickname,
        action: '',
        checkedUsers: [],
        processing: false,
        selectedKeyword: '',
        selectedUsertype: '',
        selectedSort: 'desc'
      };
    },
    mounted() {
      this.getActiveUsers();
      this.getMessages();
    },
    watch: {
      $route(to, from) {
        // get the index of the previous route
        this.setActiveChat(this.formatPayload(from.params.accountid, false));
      }
    },
    computed: {
      ...mapState({
        agentSessions: state => state.session.agentSessions,
        generalSessions: state => state.session.generalSessions,
        keywords: state => state.general.keywords.map(keyword => keyword.data.keyword).sort()
      }),
      ...mapGetters(['getChatIndex', 'getChatSessionType'])
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue